<script setup lang="ts">
import { onErrorCaptured, reactive } from 'vue';
import { logger } from '@/lib/logger.ts';

interface ComponentState {
    error: unknown | undefined;
    errorMessage: string;
}

const state: ComponentState = reactive({
    error: undefined,
    errorMessage: '',
});

const backToIndex = () => {
    window.location.href = '/';
};

onErrorCaptured((error: unknown, _, info: string) => {
    state.error = error;

    if (error instanceof Error) {
        state.errorMessage = error.message;
    } else {
        state.errorMessage = info;
    }

    logger.error('Error captured in ErrorBoundary:', error, info);

    return false;
});
</script>

<template>
    <div v-if="state.error" class="flex-shrink flex-grow p-20 text-center">
        <div class="flex flex-col gap-y-6">
            <h2 class="text-lg text-red-700">
                The ancient runes failed to compile. Give us a moment to re-enchant them! (something
                went very wrong) ✨
            </h2>
            <code class="w-md overflow-hidden rounded border p-2 text-muted-foreground">
                {{ state.errorMessage }}
            </code>

            <span class="text-muted-foreground"
                >Our engineering wizards have been notified. Click
                <a href="javascript:void(0)" @click="backToIndex" class="underline">here</a> to go
                back.</span
            >
        </div>
    </div>
    <slot v-else></slot>
</template>
